<template>
  <div class="analysis_detaisBox" v-show="analysisDetaisVisible">
    <div class="analysis_detais">
      <h1>投前分析</h1>
      <img :src="close" alt="关闭" @click="analysisDetaisCloseClick()" />
      <div class="analysis_detais_box">
        <div class="analysis_detais_bigBox">
          <div class="analysis_detais_boxLeft">
            <span class="analysis_detais_boxLeft_title">
              {{ analysisDetaisObject.profile.title }}
            </span>
            <span class="analysis_detais_boxLeft_some">
              <img
                class="img"
                :src="analysisDetaisObject.profile.avatar"
                alt="analysisDetaisObject.profile.mpname"
              />
              <span class="spanTitle">
                <span class="spanTop">
                  <span>{{ analysisDetaisObject.profile.mpname }}</span>
                  <span>{{ analysisDetaisObject.profile.wx }}</span>
                </span>
                <span class="spanBottom">
                  主体信息：{{ analysisDetaisObject.profile.mp_owner }}
                  （共
                  <span style="color: #20a0ff">
                    {{ analysisDetaisObject.profile.owner_count }}
                  </span>
                  个公众号）
                </span>
              </span>
            </span>
            <span class="span_content">
              <span>
                <span>文章位置：</span>
                <span>{{
                  positionShow(analysisDetaisObject.profile.position)
                }}</span>
              </span>
              <span>
                <span>发文时间：</span>
                <span>{{ analysisDetaisObject.profile.pubtime }}</span>
              </span>
              <span>
                <span>开始监控时间：</span>
                <span>{{ analysisDetaisObject.profile.start_ts }}</span>
              </span>
              <span>
                <span>结束监控时间：</span>
                <span>{{ analysisDetaisObject.profile.end_ts }}</span>
              </span>
            </span>
          </div>
          <div class="analysis_detais_boxRight">
            <!-- <div class="analysis_detais_boxRight_stauts">
          {{ analysisDetaisObject.profile.status }}
        </div> -->
            <div class="stuts1 blueColor">
              <p class="tx1">监控</p>
              <p class="tx2">完成</p>
            </div>
            <span class="collection"> 收藏报告 </span>
            <div class="time_box">
              <span class="adrss">监控结果：</span>
              <span class="gray" v-show="analysisDetaisObject.status == 0"
                >正常</span
              >
              <span class="gray" v-show="analysisDetaisObject.status == 1"
                >刷量</span
              >
            </div>
            <div class="time_box">
              <span class="adrss">预估阅读刷量：</span>
              <span class="gray">{{ analysisDetaisObject.forecast_fake }}</span>
            </div>
            <div class="time_box">
              <span class="adrss">预估阅读刷量占比：</span>
              <span class="gray">{{
                analysisDetaisObject.forecast_fake_per
              }}</span>
            </div>
          </div>
        </div>
        <!-- 数据折线图 -->
        <div class="analysis_detais_charts">
          <div class="tips_box">
            <div class="tab_box">
              <div
                v-for="(chartsVarItem, index) in chartsVar"
                :key="index"
                class="chartBtn"
                @click.passive="
                  chartsMethods(analysisDetaisObject, chartsVarItem, index)
                "
              >
                {{ chartsVarItem }}
              </div>
              <!-- <div class="btn" @click="tabMethod(0)">监控视图</div>
            <div class="btn" @click="tabMethod(1)">增量视图</div> -->
            </div>
          </div>
          <div id="chartMain" style="width: 100%; height: 400px"></div>
          <!-- <div id="chartMain2" style="width: 100%"></div> -->
        </div>
        <!-- 监控数据记录 -->
        <div class="analysis_data_record">
          <span class="analysis_data_recordTop">
            <span>日期</span>
            <span>阅读</span>
            <span>新增阅读</span>
            <span>点赞</span>
            <span>新增点赞</span>
          </span>
          <span class="analysis_data_recordList"> </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  name: "analysisDetais",
  data() {
    return {
      close: require("@/common/assets/close.png"),
      readList: [],
      timeList: [],
      praiseList: [],
      readList2: [],
      timeList2: [],
      praiseList2: [],
      chartsVar: ["监控视图"],
    };
  },
  props: {
    analysisDetaisVisible: {
      type: Boolean,
      default: false,
    },
    analysisDetaisObject: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    // this.drawLine("main");
  },
  computed: {
    positionShow() {
      return (position) => {
        switch (position) {
          case 1:
            return "头条";
          case 2:
            return "二条";
          case 3:
            return "三条";
          case 4:
            return "四条";
          case 5:
            return "五条";
          case 6:
            return "六条";
          case 7:
            return "七条";
          case 8:
            return "八条";
        }
      };
    },
  },
  methods: {
    analysisDetaisCloseClick() {
      this.$emit("analysisDetaisCloseClick");
    },
    chartsMethods(analysisDetaisObject, item, index) {
      // console.log(analysisDetaisObject);
      switch (index) {
        case 0:
          let that = this;
          //   导出所有阅读数read
          that.readList.push(
            analysisDetaisObject.charts.map((eleItem) => {
              return eleItem.read;
            })
          );
          //   导出所有 time
          that.timeList.push(
            analysisDetaisObject.charts.map((eleItem) => {
              return eleItem.time;
            })
          );
          // 导出所有赞 praise
          that.praiseList.push(
            analysisDetaisObject.charts.map((eleItem) => {
              return eleItem.praise;
            })
          );

          let chart = echarts.init(document.getElementById("chartMain"));
          chart.setOption({
            // Make gradient line here
            visualMap: [
              {
                show: false,
                type: "continuous",
                seriesIndex: 0,
                min: 0,
                max: 400,
              },
              {
                show: false,
                type: "continuous",
                seriesIndex: 1,
                dimension: 0,
                min: 0,
                max: this.timeList.length - 1,
              },
            ],
            title: [
              {
                left: "center",
                text: "点赞",
              },
              {
                top: "55%",
                left: "center",
                text: "阅读",
              },
            ],
            tooltip: {
              trigger: "axis",
            },
            xAxis: [
              {
                data: this.timeList.length,
              },
              {
                data: this.timeList.length,
                gridIndex: 1,
              },
            ],
            yAxis: [
              {},
              {
                gridIndex: 1,
              },
            ],
            grid: [
              {
                bottom: "60%",
              },
              {
                top: "60%",
              },
            ],
            series: [
              {
                type: "line",
                showSymbol: false,
                data: that.praiseList[that.praiseList.length - 1],
              },
              {
                type: "line",
                showSymbol: false,
                data: that.readList[that.readList.length - 1],
                xAxisIndex: 1,
                yAxisIndex: 1,
              },
            ],
          });
          break;
        case 1:
          //   let that = this;
          // console.log("1");
          this.$http.axiosFun(
            this.$api.monitor.read_praise,
            {
              post: analysisDetaisObject.post,
              type: 2,
            },
            (res) => {
              // console.log(res);
              //   导出所有阅读数read
              this.readList2.push(
                res.data.charts.map((eleItem) => {
                  return eleItem.read;
                })
              );
              //   导出所有 time
              this.timeList2.push(
                res.data.charts.map((eleItem) => {
                  return eleItem.time;
                })
              );
              // 导出所有赞 praise
              this.praiseList2.push(
                res.data.charts.map((eleItem) => {
                  return eleItem.praise;
                })
              );
              // console.log(this.timeList2);
              let chart2 = echarts.init(document.getElementById("chartMain2"));
              //   chart2.setOption({
              //     xAxis: {
              //       type: "category",
              //       data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
              //     },
              //     yAxis: {
              //       type: "value",
              //     },
              //     series: [
              //       {
              //         data: [820, 932, 901, 934, 1290, 1330, 1320],
              //         type: "line",
              //         smooth: true,
              //       },
              //     ],
              //   });
            }
          );
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  border: none;
  background-color: #fff;
}
.analysis_detaisBox {
  width: 100%;
  height: 100%;
  background-color: rgba(29, 29, 29, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5200;
  .analysis_detais {
    width: 1400px;
    height: 100%;
    background-color: #fff;
    margin-left: calc(100% / 2 - 1400px / 2);
    // margin-top: 2%;
    position: fixed;
    .analysis_detais_box::after {
      content: "";
      clear: both;
      display: inline-block;
    }
    .analysis_detais_box {
      border: solid 1px;
      width: 100%;
      height: 90%;
      overflow-x: hidden;
      display: block;
      padding: 0 20px;
      box-sizing: border-box;
      .analysis_detais_bigBox {
        border: solid 1px;
        display: inline-block;
        width: 100%;
        .analysis_detais_boxLeft::after {
          content: "";
          clear: both;
          display: inline-block;
        }
        .analysis_detais_boxLeft {
          width: 76%;
          float: left;
          //   border: solid 1px;
          box-sizing: border-box;
          .analysis_detais_boxLeft_title {
            font-size: 24px;
            width: 100%;
            height: 50px;
            display: inline-block;
            font-weight: 700;
            line-height: 50px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .analysis_detais_boxLeft_some {
            // border: solid 1px;
            width: 100%;
            height: 150px;
            display: inline-block;
            float: left;
            .img {
              float: left;
              width: 120px;
              height: 120px;
              box-sizing: border-box;
              border-radius: 100%;
              border: solid 1px #ccc;
              display: inline-block;
              margin-top: calc(150px / 2 - 120px / 2);
            }
            .spanTitle {
              width: calc(100% - 140px);
              display: inline-block;
              height: 150px;
              box-sizing: border-box;
              //   border: solid 1px;
              float: right;
              .spanTop {
                width: 100%;
                display: inline-block;
                // border: solid 1px;
                height: 80px;
                span:first-child {
                  font-size: 22px;
                  font-weight: 600;
                  line-height: 100px;
                }
                span:nth-child(2) {
                  font-size: 18px;
                  margin-left: 10px;
                  color: #999;
                  font-weight: 700;
                }
              }
              .spanBottom {
                font-size: 18px;
                color: #666;
              }
            }
          }
          .span_content {
            // border: solid 1px blue;
            display: inline-block;
            width: 100%;
            margin-top: 30px;
            box-sizing: border-box;
          }
          .span_content > span {
            // border: solid 1px;
            width: 100%;
            font-size: 20px;
            display: inline-block;
            height: 40px;
            line-height: 40px;
            span:first-child {
              font-weight: 600;
            }
            span:nth-child(2) {
              color: #666;
            }
          }
        }
        .analysis_detais_boxRight {
          width: 24%;
          float: left;
          //   border: solid 1px;
          box-sizing: border-box;
          .stuts1 {
            display: block;
            border-radius: 100%;
            border: solid 4px #20a0ff;
            width: 120px;
            height: 120px;
            text-align: center;
            font-size: 30px;
            font-weight: 700;
            color: #20a0ff;
            p {
              //   float: left;
              margin-top: calc(120px / 2 - 78px / 2);
            }
            p:nth-child(2) {
              margin-top: 0;
            }
          }
          .collection {
            cursor: pointer;
            display: inline-block;
            background-color: #20a0ff;
            width: 90px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            color: #fff;
            border-radius: 4px;
            margin-left: 15px;
            margin-top: 20px;
          }
          .time_box {
            width: 100%;
            display: inline-block;
            // border: solid 1px;
            height: 50px;
            font-size: 20px;
            margin-top: 10px;
            line-height: 50px;
            box-sizing: border-box;
            span:first-child {
              font-weight: 600;
            }
            span:nth-child(2) {
              color: #666;
            }
          }
        }
      }
      .analysis_detais_charts {
        width: 100%;
        //   height: 900px;
        border: solid 1px;
        display: inline-block;
        .tips_box {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          // padding: 0 50px;
          margin-top: 30px;
          .tab_box {
            width: 90px;
            height: 35px;
            line-height: 35px;
            display: flex;
            text-align: center;
            border: solid 1px;
            border-radius: 5px;
            overflow: hidden;
            .chartBtn {
              margin-left: 10px;
            }
            .btn {
              width: 125px;
              text-align: center;
              border: 2px solid #999999;
              cursor: pointer;
            }
            .btn_act {
              background: #20a0ff;
              color: #ffffff;
              border: 2px solid #20a0ff;
            }
          }
          .tips_text {
            width: 420px;
            display: flex;
            justify-content: space-between;
            .tips {
              display: flex;
              align-items: center;
              font-weight: bold;
              font-size: 16px;
              .blue_heng {
                display: inline-block;
                width: 30px;
                height: 3px;
                background: #20a0ff;
                margin-right: 10px;
              }
              .org_heng {
                display: inline-block;
                width: 30px;
                height: 3px;
                background: #ff8e20;
                margin-right: 10px;
              }
            }
          }
        }
      }
      .analysis_data_record {
        border: solid 1px;
        width: 100%;
        float: left;
        margin-top: 10px;
      }
    }
  }
  .analysis_detais > h1 {
    width: 100%;
    height: 80px;
    box-sizing: border-box;
    border: solid 1px #ccc;
    border-top: none;
    border-left: none;
    border-right: none;
    font-size: 26px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 600;
    line-height: 90px;
    text-align: center;
    color: #000000;
  }
  .analysis_detais > img {
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/searchPopup/analysis-details.vue